module.exports = __webpack_public_path__ + "img/logout.3e94ef11.svg";